// Check if the pop-up has been visited before using cookies
let cookieStatus = Cookies.get('popUpVisited');

// Set the delay time in milliseconds (e.g., 5000 milliseconds = 5 seconds)
const delayTime = 6000; // Adjust this value as needed

// Function to display the pop-up after the delay
function displayPopUp() {
    const popUpForm = document.getElementById('customNewsletter');
    console.log("passed condition");
    popUpForm.style.display = "flex";
    Cookies.set('popUpVisited', 'true', { expires: 1 });
}

// Check if the pop-up has not been visited before and if it's time to display it
if (!cookieStatus) {
    // Set a timeout to display the pop-up after the delay
    setTimeout(displayPopUp, delayTime);
}
 